import { 	FETCH_ONE_FUEHRERSCHEIN,
					FETCH_ONE_FUEHRERSCHEIN_ERROR
				} from '../actions/types';

export default function (state = [], action) {
	switch (action.type) {
		case FETCH_ONE_FUEHRERSCHEIN:
			console.log("action FETCH_ONE_FUEHRERSCHEIN");
			return action.payload || false;
		case FETCH_ONE_FUEHRERSCHEIN_ERROR:
			console.log("action FETCH_ONE_FUEHRERSCHEIN_ERROR, es ist was schiefgegangen");
			return action.payload || false;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fuehrerscheinReducer.js